import axios from 'axios';

const api = axios.create({
  baseURL: 'https://backend.clubecliente.com',
  // baseURL: 'http://localhost:3334',
});

export default api;
